var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column"},[_c('b-image',{attrs:{"src":_vm.src,"alt":_vm.desc,"ratio":"600by825"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }